module.exports = __webpack_public_path__ + "static/media/button-border-3.1307e786.svg";